import HTTP from '.';
import ActivityAreaServiceMock from './mocks/ActivityAreaService.mock';
import config from '@/config';

export default class ActivityAreaService {
  static getActivtyAreas() {
    if (config.ENV.MOCK === true) {
      return ActivityAreaServiceMock.getActivtyAreas();
    }

    return HTTP.get('/api/ActivityArea');
  }

  static getActivityAreaById(id) {
    if (config.ENV.MOCK === true) {
      return ActivityAreaServiceMock.getActivityAreaById();
    }

    return HTTP.get(`/api/ActivityArea/${id}`);
  }
}
